"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = require("./AnalyticsProvider");
var GenericProvider = /** @class */ (function (_super) {
    __extends(GenericProvider, _super);
    function GenericProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * General Events
     */
    GenericProvider.prototype.opened = function (dealId, vehicle) {
        console.log("opened", dealId, vehicle);
    };
    GenericProvider.prototype.closed = function (dealId, vehicle) {
        console.log("closed", dealId, vehicle);
    };
    GenericProvider.prototype.dealCreated = function (dealId, vehicle) {
        console.log("dealCreated", dealId, vehicle);
    };
    GenericProvider.prototype.vehicleAdded = function (dealId, vehicle) {
        console.log("vehicleAdded", dealId, vehicle);
    };
    GenericProvider.prototype.vehicleRemoved = function (dealId, vehicle) {
        console.log("vehicleRemoved", dealId, vehicle);
    };
    /**
     * Payment Calculator Events
     */
    GenericProvider.prototype.paymentCalcViewed = function (dealId, vehicle) {
        console.log("paymentCalcViewed", dealId, vehicle);
    };
    GenericProvider.prototype.paymentCalcInteraction = function (dealId, vehicle) {
        console.log("paymentCalcInteraction", dealId, vehicle);
    };
    GenericProvider.prototype.paymentCalcFinished = function (dealId, vehicle) {
        console.log("paymentCalcFinished", dealId, vehicle);
    };
    /**
     * Garage Events
     */
    GenericProvider.prototype.garageViewed = function (dealId, vehicle) {
        console.log("garageViewed", dealId, vehicle);
    };
    GenericProvider.prototype.garageInteraction = function (dealId, vehicle) {
        console.log("garageInteraction", dealId, vehicle);
    };
    /**
     * Test Drive Events
     */
    GenericProvider.prototype.testDriveShown = function (dealId, vehicle) {
        console.log("testDriveShown", dealId, vehicle);
    };
    GenericProvider.prototype.testDriveStarted = function (dealId, vehicle) {
        console.log("testDriveStarted", dealId, vehicle);
    };
    GenericProvider.prototype.testDriveFinished = function (dealId, vehicle) {
        console.log("testDriveFinished", dealId, vehicle);
    };
    /**
     * Upgrade Events
     */
    GenericProvider.prototype.upgradesViewed = function (dealId, vehicle) {
        console.log("upgradesViewed", dealId, vehicle);
    };
    GenericProvider.prototype.upgradeAdded = function (id, dealId, vehicle, addOnName) {
        console.log("upgradeAdded", id, dealId, vehicle, addOnName);
    };
    GenericProvider.prototype.upgradesFinished = function (dealId, vehicle) {
        console.log("upgradesFinished", dealId, vehicle);
    };
    /**
     * F&I Events
     */
    GenericProvider.prototype.menuingViewed = function (dealId, vehicle) {
        console.log("menuingViewed", dealId, vehicle);
    };
    GenericProvider.prototype.ancillaryProductAdded = function (dealId, vehicle, productName) {
        console.log("ancillaryProductAdded", dealId, vehicle, productName);
    };
    GenericProvider.prototype.menuingFinished = function (dealId, vehicle) {
        console.log("menuingFinished", dealId, vehicle);
    };
    /**
     * Reserve Vehicle Events
     */
    GenericProvider.prototype.reserveVehicleFormViewed = function (dealId, vehicle) {
        console.log("reserveVehicleFormViewed", dealId, vehicle);
    };
    GenericProvider.prototype.reserveVehicleFormStarted = function (dealId, vehicle) {
        console.log("reserveVehicleFormStarted", dealId, vehicle);
    };
    GenericProvider.prototype.reserveVehicleFormFinished = function (dealId, vehicle) {
        console.log("reserveVehicleFormFinished", dealId, vehicle);
    };
    /**
     * Trade In Form Events
     */
    GenericProvider.prototype.tradeInFormViewed = function (dealId, vehicle) {
        console.log("tradeInFormViewed", dealId, vehicle);
    };
    GenericProvider.prototype.tradeInFormStarted = function (dealId, vehicle) {
        console.log("tradeInFormStarted", dealId, vehicle);
    };
    GenericProvider.prototype.tradeInFormFinished = function (dealId, vehicle) {
        console.log("tradeInFormFinished", dealId, vehicle);
    };
    /**
     * Lead Form Events
     */
    GenericProvider.prototype.leadFormViewed = function (dealId, vehicle) {
        console.log("leadFormViewed", dealId, vehicle);
    };
    GenericProvider.prototype.leadFormStarted = function (dealId, vehicle) {
        console.log("leadFormStarted", dealId, vehicle);
    };
    GenericProvider.prototype.leadFormFinished = function (dealId, vehicle) {
        console.log("leadFormFinished", dealId, vehicle);
    };
    /**
     * Schedule Pickup / Delivery form
     */
    GenericProvider.prototype.schedulePickupOrDeliveryFormViewed = function (dealId, vehicle) {
        console.log("schedulePickupOrDeliveryFormViewed", dealId, vehicle);
    };
    GenericProvider.prototype.schedulePickupOrDeliveryFormStarted = function (dealId, vehicle) {
        console.log("schedulePickupOrDeliveryFormStarted", dealId, vehicle);
    };
    GenericProvider.prototype.schedulePickupOrDeliveryFormFinished = function (dealId, vehicle) {
        console.log("schedulePickupOrDeliveryFormFinished", dealId, vehicle);
    };
    GenericProvider.prototype.pickDeliveryDate = function (date) {
        console.log("pickDeliveryDate");
    };
    GenericProvider.prototype.pickDeliveryTime = function (time) {
        console.log("pickDeliveryTime");
    };
    /**
     * Soft Credit Pull
     */
    GenericProvider.prototype.softCreditFormViewed = function (dealId, vehicle) {
        console.log("Soft credit form viewed", dealId, vehicle);
    };
    GenericProvider.prototype.softCreditFormStarted = function (dealId, vehicle) {
        console.log("Soft credit form started", dealId, vehicle);
    };
    GenericProvider.prototype.softCreditFormFinished = function (dealId, vehicle, applicationId) {
        console.log("Soft credit form finished", dealId, vehicle, applicationId);
    };
    /**
     * Hard Credit Pull
     */
    GenericProvider.prototype.hardCreditFormViewed = function (dealId, vehicle) {
        console.log("Hard credit form viewed", dealId, vehicle);
    };
    GenericProvider.prototype.hardCreditFormStarted = function (dealId, vehicle) {
        console.log("Hard credit form started", dealId, vehicle);
    };
    GenericProvider.prototype.hardCreditFormFinished = function (dealId, vehicle, applicationId) {
        console.log("Hard credit form finished", dealId, vehicle, applicationId);
    };
    /**
     * TODO Events. Move events above this comment to their respective section as they get refactored for Shift v2
     */
    GenericProvider.prototype.tradeInStart = function (dealId, vehicle) {
        console.log("Trade in start.", dealId, vehicle);
    };
    GenericProvider.prototype.tradeInEstimate = function (dealId, vehicle) {
        console.log("Trade in estimate.", dealId, vehicle);
    };
    GenericProvider.prototype.tradeInComplete = function (dealId, vehicle) {
        console.log("Trade in complete.", dealId, vehicle);
    };
    GenericProvider.prototype.leadFormStart = function (dealId, vehicle) {
        console.log("Start form lead", dealId, vehicle);
    };
    GenericProvider.prototype.leadFormFinish = function (dealId, vehicle) {
        console.log("Finish form lead", dealId, vehicle);
    };
    GenericProvider.prototype.signInToGarageGarageIcon = function () {
        console.log("signInToGarageGarageIcon");
    };
    GenericProvider.prototype.skipCreditApp = function () {
        console.log("skipCreditApp");
    };
    GenericProvider.prototype.creditAppPrimaryPageTwo = function () {
        console.log("creditAppPrimaryPageTwo");
    };
    GenericProvider.prototype.cosignerYes = function () {
        console.log("cosignerYes");
    };
    GenericProvider.prototype.continueDeal = function (vin, dealId, vehicle) {
        console.log("continueDeal", { vin: vin, dealId: dealId, vehicle: vehicle });
    };
    GenericProvider.prototype.virtualPageView = function (pagePath) {
        console.log("virtualPageView", pagePath);
    };
    return GenericProvider;
}(AnalyticsProvider_1.AnalyticsProvider));
exports.default = GenericProvider;
